import { render, staticRenderFns } from "./NewsHeadlines.vue?vue&type=template&id=b6dd9416&scoped=true&"
import script from "./NewsHeadlines.vue?vue&type=script&lang=js&"
export * from "./NewsHeadlines.vue?vue&type=script&lang=js&"
import style0 from "./NewsHeadlines.vue?vue&type=style&index=0&id=b6dd9416&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dd9416",
  null
  
)

export default component.exports